<template>
    <v-menu
        bottom
        left
        origin="top bottom"
        transition="scale-transition"
        offset-y
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                dark
                icon
                v-bind="attrs"
                v-on="on"
            >
                <v-icon >$dotsVertical</v-icon>
            </v-btn>
        </template>

        <v-list>
            <v-list-item>
                <v-list-item-title>
                    <cp-button
                        leftIcon="$account"
                        color="white"
                        :href="route('v2.users.edit', [user.id])"
                    >
                        Perfil
                    </cp-button>
                </v-list-item-title>
            </v-list-item>
            <v-list-item>
                <v-list-item-title>
                    <cp-button
                        leftIcon="$formTextboxPassword"
                        color="white"
                        :href="route('v2.users.password.reset', [user.id])"
                    >
                        Alterar senha
                    </cp-button>
                </v-list-item-title>
            </v-list-item>
            <v-list-item>
                <v-list-item-title>
                    <form id="logout-form" :action="route('logout')" method="POST">
                        <cp-csrf-token/>
                        <cp-button
                            leftIcon="$logout"
                            color="white"
                            type="submit"
                        >
                            Logout
                        </cp-button>
                    </form>
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    computed: {
        user() {
            return this.getUser()
        }
    },
};
</script>

<style scoped lang="scss">
</style>
